import { BankAccountType } from '../'
export enum AchRelationshipStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Rejected = 'REJECTED'
}
export interface User {
  name?: string
  entity?: string
  userClass?: string
}
export interface ApprovalResponse {
  approvalTime?: string
  approvedBy?: User
}
export interface ErrorMessageResponse {
  errorCode?: string
  errorDescription?: string
  errorDetails?: object
  errorList?: any[]
  error?: string
  message?: string
  details?: object
}
export interface RejectionResponse {
  rejectionTime?: string
  requestedBy?: User
  rejectionReasons?: ErrorMessageResponse
}

export enum ApprovalMethod {
  MicroDeposit = 'MICRO_DEPOSIT',
  Yodlee = 'YODLEE',
  Plaid = 'PLAID',
  Quovo = 'QUOVO',
  Giact = 'GIACT',
  Synapse = 'SYNAPSE',
  Fincity = 'FINICITY',
  Sophotron = 'SOPHOTRON',
  Apex = 'APEX',
  UseExisting = 'USE_EXISTING',
  InternalBank = 'INTERNAL_BANK',
  MicroPreapproved = 'MICRO_PREAPPROVED',
  Mx = 'MX',
  VoidedCheck = 'VOIDED_CHECK'
}
export interface AchRelationshipResponsePayload {
  account: string
  bankRoutingNumber: string
  bankAccount: string
  bankAccountOwnerName: string
  bankAccountType: BankAccountType
  nickname: string
  approvalMethod: ApprovalMethod
  id?: string
  status?: AchRelationshipStatus
  approval?: ApprovalResponse
  creationTime?: string
  rejection?: RejectionResponse
}

export interface AllAchRelationshipsRequestParams {
  account: string
  status?: AchRelationshipStatus
}
